import { createFileRoute } from "@tanstack/react-router";
import { TenantUsersTab } from "../features/tenants/pages/tenant-users-tab";

export const Route = createFileRoute("/tenants/$tenantId/users")({
  component: TenantUsersTab,
});
